// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"dd07cd8b","667":"771d1b78","946":"d6a22e8b"}[chunkId] + ".chunk.js";
};